<template>
  <div>
    <b-card style="overflow-x: hidden">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
            <b-button variant="primary" :to="{ name: 'admin-users-create' }">
              Create User
            </b-button>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <label class="mr-1">
              Search
            </label>
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchWord"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
            </div>
          </b-col>
        </b-row>
      </div>
      <!-- Larger screen than mobile -->
      <div class="d-none d-md-flex">
        <b-table
          responsive
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items="items"
          :fields="fields"
          :no-local-sorting="true"
          :busy="isBusy"
          class="w-100"
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner
                class="align-middle mr-1"
                variant="secondary"
              ></b-spinner>
              <strong class="text-secondary">Loading...</strong>
            </div>
          </template>
          <template #cell(action)="data">
            <div class="d-flex justify-content-start">
              <!-- User Expired function, not part of D2P rundown, disabled for now -->
              <!-- <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-modal.usr-exp-conf
                variant="success"
                class="btn-icon mr-1"
                @click="openUserExpiredModal(data.item)"
              >
                <feather-icon icon="EyeIcon" />
              </b-button> -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="secondary"
                class="btn-icon mr-1"
                @click="
                  $router.push({
                    name: 'admin-users-edit',
                    params: { key: data.item.KODE },
                  })
                "
              >
                <feather-icon icon="Edit3Icon" />
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="btn-icon mr-1"
                @click="showMsgBoxDelete(data.item)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </div>
          </template>
          <template #cell(role)="data">
            {{ data.item.roles.length > 0 ? data.item.roles[0] : '' }}
          </template>
          <!-- <template #cell(expired_at)="data">
            {{ formatExpiredAt(data.item.expired_at) }}
          </template> -->
        </b-table>
      </div>
      <!-- Mobile screen -->
      <div class="d-flex d-md-none flex-column">
        <!-- Loading -->
        <div v-if="isBusy" class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
          <strong class="text-secondary">Loading...</strong>
        </div>
        <!-- Data -->
        <div
          v-if="!isBusy && items.length == 0"
          class="text-center text-danger my-2"
        >
          <strong class="text-secondary">No data</strong>
        </div>
        <b-row
          v-for="(item, index) in items"
          v-if="!isBusy && items.length > 0"
          :key="item.id"
          class="mb-3 list-item"
        >
          <b-col
            cols="12"
            class="d-flex flex-wrap justify-content-end align-items-center mb-1"
            style="gap: 1rem;"
          >
            <strong class="flex-grow-1 truncate">{{ item.USERNAME }}</strong>
            <div>
              <!-- User Expired function, not part of D2P rundown, disabled for now -->
              <!-- <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-modal.usr-exp-conf
                variant="success"
                class="btn-icon mr-1"
                @click="openUserExpiredModal(item)"
              >
                <feather-icon icon="EyeIcon" />
              </b-button> -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="secondary"
                class="btn-icon mr-1"
                @click="
                  $router.push({
                    name: 'admin-users-edit',
                    params: { key: item.KODE },
                  })
                "
              >
                <feather-icon icon="Edit3Icon" />
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="btn-icon mr-1"
                @click="showMsgBoxDelete(item)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </div>
          </b-col>
          <b-col cols="12" class="d-flex flex-wrap">
            <div style="font-size: 0.75rem;">
              <p><strong>NAME:</strong> {{ item.NAME || '-' }}</p>
              <p><strong>EMAIL:</strong> {{ item.EMAIL_ADDRESS || '-' }}</p>
              <p><strong>JABATAN:</strong> {{ item.JABATAN || '-' }}</p>
              <p><strong>DIVISI:</strong> {{ item.DIVISION || '-' }}</p>
              <p>
                <strong>ROLE:</strong>
                {{ item.roles.length > 0 ? item.roles[0] : '-' }}
              </p>
              <!-- <p>
                <strong>EXPIRED AT:</strong>
                {{ formatExpiredAt(item.expired_at) }}
              </p> -->
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ currentPage * perPage - perPage + 1 }} to
              {{ currentPage * perPage - perPage + showData }} of
              {{ totalData }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalData"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="inputPagination"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
      id="image-review"
      scrollable
      title="Image Review"
      ok-title="Close"
      centered
      cancel-variant="outline-secondary"
      :ok-only="true"
      size="md"
    >
      <b-card-text>
        <b-row class="justify-content-center">
          <b-col md="8" sm="4">
            <b-img thumbnail fluid rounded :src="imgSelectedItem"> </b-img>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <!-- User Expired function, not part of D2P rundown, disabled for now -->
    <!-- <b-modal
      id="usr-exp-conf"
      title="User Expired Configuration"
      size="lg"
      hide-footer
    >
      <div class="usr-exp-modal">
        <b-card class="mb-1 usr-exp-section">
          <h5 class="mb-75">User Info Card</h5>
          <b-row>
            <b-col cols="12" md="6" class="mb-50">
              <div class="text-muted small">Username</div>
              <div class="font-weight-bold">
                {{ selectedExpiredUser.USERNAME || '-' }}
              </div>
            </b-col>
            <b-col cols="12" md="6" class="mb-50">
              <div class="text-muted small">Name</div>
              <div class="font-weight-bold">
                {{ selectedExpiredUser.NAME || '-' }}
              </div>
            </b-col>
            <b-col cols="12" md="6" class="mb-50">
              <div class="text-muted small">Email</div>
              <div class="font-weight-bold">
                {{ selectedExpiredUser.EMAIL_ADDRESS || '-' }}
              </div>
            </b-col>
            <b-col cols="12" md="6" class="mb-50">
              <div class="text-muted small">Role</div>
              <div class="font-weight-bold">{{ selectedExpiredUserRole }}</div>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="mb-1 usr-exp-section">
          <h5 class="mb-75">Current Expired Card</h5>
          <div class="mb-50">
            <span class="text-muted">Expired:</span>
            <span class="font-weight-bold ml-50">{{
              formattedExpiredWib
            }}</span>
          </div>
          <div>
            <span class="text-muted">Last updated by</span>
            <span class="font-weight-bold"> {{ expiredLastUpdatedBy }}</span>
          </div>
          <div class="mt-1">
            <b-button
              size="sm"
              variant="primary"
              @click="showSetExpiryForm = !showSetExpiryForm"
            >
              {{ showSetExpiryForm ? 'Close Set Expiry' : 'Set Expiry' }}
            </b-button>
          </div>
          <div v-if="showSetExpiryForm" class="mt-1">
            <b-row>
              <b-col cols="12" md="6" class="mb-1">
                <label class="mb-50">Expired At</label>
                <b-form-input
                  v-model="setExpiryForm.expired_at"
                  type="datetime-local"
                />
              </b-col>
              <b-col cols="12" md="6" class="mb-1">
                <label class="mb-50">Reason</label>
                <b-form-input
                  v-model="setExpiryForm.reason"
                  placeholder="Reason for change"
                />
              </b-col>
              <b-col cols="12">
                <b-button
                  size="sm"
                  variant="success"
                  :disabled="isSubmittingSetExpiry"
                  @click="submitSetExpiry"
                >
                  {{ isSubmittingSetExpiry ? 'Saving...' : 'Save Expiry' }}
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-card>

        <b-card class="mb-1 usr-exp-section">
          <h5 class="mb-1">Activity Timeline</h5>
          <ul class="usr-exp-timeline pl-1 mb-0">
            <li
              v-for="(history, idx) in expiredHistory"
              :key="`${history.changedAt}-${idx}`"
              class="mb-1"
            >
              <div class="font-weight-bold">{{ history.changedAt }}</div>
              <div class="text-muted">
                {{ history.changedBy }} changed expiry to
                {{ history.expiredTo }}
              </div>
            </li>
          </ul>
        </b-card>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BSpinner,
  BFormCheckbox,
  BModal,
  BImg,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    BFormCheckbox,
    BModal,
    BImg,

    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      perPage: '10',
      perPageOptions: ['10', '20', '30'],
      currentPage: 1,
      totalData: 200,
      showData: 0,
      items: [],
      sortBy: 'USERNAME',
      sortDesc: true,
      searchWord: '',
      isBusy: false,

      selectedItem: {
        icon: '',
        icon_details: {},
      },
      selectedExpiredUser: {},
      expiredLastUpdatedBy: '-',
      showExpiredDetail: true,
      expiredHistory: [],
      expiredDetailFields: [
        { key: 'field', label: 'Field' },
        { key: 'before', label: 'Before' },
        { key: 'after', label: 'After' },
        { key: 'action', label: 'Action' },
        { key: 'reason', label: 'Reason' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'changedAt', label: 'Changed At' },
      ],
      expiredDetailRows: [],
      showSetExpiryForm: false,
      isSubmittingSetExpiry: false,
      setExpiryForm: {
        expired_at: '',
        reason: '-',
      },
    }
  },
  computed: {
    skip() {
      return this.perPage * (this.currentPage - 1)
    },
    imgSelectedItem() {
      return typeof this.selectedItem.icon_details === 'object' &&
        typeof this.selectedItem.icon_details.original === 'object'
        ? this.selectedItem.icon_details.original.url
        : ''
    },
    fields() {
      const toShow = [
        { key: 'USERNAME', label: 'username', sortable: true },
        { key: 'NAME', sortable: true },
        { key: 'EMAIL_ADDRESS', label: 'email', sortable: true },
        { key: 'JABATAN', sortable: true },
        { key: 'DIVISION', label: 'divisi', sortable: true },
        // { key: 'expired_at', label: 'expired at', sortable: true }, // Not part of D2P rundown, disabled for now
        'role',
        'action',
      ]

      return toShow
    },
    selectedExpiredUserRole() {
      if (
        !this.selectedExpiredUser ||
        !Array.isArray(this.selectedExpiredUser.roles)
      )
        return '-'
      return this.selectedExpiredUser.roles.length > 0
        ? this.selectedExpiredUser.roles[0]
        : '-'
    },
    formattedExpiredWib() {
      if (!this.selectedExpiredUser || !this.selectedExpiredUser.expired_at) {
        return '-'
      }
      return this.formatExpiredAt(this.selectedExpiredUser.expired_at).replace(
        /(, \d{2}:\d{2})(?!.*WIB)/,
        '$1 WIB'
      )
    },
  },
  watch: {
    perPage() {
      this.getUser()
    },
    currentPage() {
      this.getUser()
    },
    searchWord() {
      this.$store.dispatch('app/search', {
        callback: () => {
          this.getUser()
        },
      })
    },
  },
  mounted() {
    this.getUser()
  },
  methods: {
    formatExpiredAt(value) {
      if (!value) return '-'

      const normalizedValue = String(value).replace(/\.(\d{3})\d*Z$/, '.$1Z')
      const date = new Date(normalizedValue)

      if (Number.isNaN(date.getTime())) return value

      return date
        .toLocaleString('id-ID', {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
          timeZone: 'Asia/Jakarta',
        })
        .replace(' pukul ', ', ')
    },
    async openUserExpiredModal(item) {
      this.selectedExpiredUser = item || {}
      this.showExpiredDetail = true
      this.showSetExpiryForm = false
      this.setExpiryForm = {
        expired_at: '',
        reason: '-',
      }
      this.expiredHistory = []
      this.expiredDetailRows = []
      this.expiredLastUpdatedBy = '-'
      await this.getUserExpiryHistory(item.KODE)
    },
    mapActedByLabel(actedBy, accountMe) {
      if (!actedBy) return '-'
      if (accountMe && String(actedBy) === String(accountMe.KODE)) {
        return accountMe.USERNAME || String(actedBy)
      }
      return String(actedBy)
    },
    async getUserExpiryHistory(userKode) {
      if (!userKode) return
      return await this.$http
        .get(`/user/${userKode}/expiry-history`)
        .then(res => {
          const records = (((res || {}).data || {}).data || {}).records || []
          const accountMe = (((res || {}).data || {}).account || {}).me || null

          if (records.length > 0) {
            const latest = records[0]
            this.selectedExpiredUser = {
              ...this.selectedExpiredUser,
              expired_at: latest.new_expired_at,
            }
            this.setExpiryForm.expired_at = this.formatDateTimeLocal(
              latest.new_expired_at
            )
            this.expiredLastUpdatedBy = this.mapActedByLabel(
              latest.acted_by_name,
              accountMe
            )
          }

          this.expiredHistory = records.map(record => ({
            changedAt: `${this.formatExpiredAt(record.created_at)} WIB`,
            changedBy: this.mapActedByLabel(record.acted_by_name, accountMe),
            expiredTo: `${this.formatExpiredAt(record.new_expired_at)} WIB`,
          }))

          this.expiredDetailRows = records.map(record => ({
            field: 'expired_at',
            before: record.old_expired_at
              ? `${this.formatExpiredAt(record.old_expired_at)} WIB`
              : '-',
            after: record.new_expired_at
              ? `${this.formatExpiredAt(record.new_expired_at)} WIB`
              : '-',
            action: record.action || '-',
            reason: record.reason || '-',
            updatedBy: this.mapActedByLabel(record.acted_by_name, accountMe),
            changedAt: `${this.formatExpiredAt(record.created_at)} WIB`,
          }))
        })
        .catch(() => {
          this.expiredHistory = []
          this.expiredDetailRows = []
          this.expiredLastUpdatedBy = '-'
          this.$notif(
            'Something Error',
            'Failed to fetch expiry history',
            'danger'
          )
        })
    },
    formatDateTimeLocal(value) {
      if (!value) return ''
      const date = new Date(String(value))
      if (Number.isNaN(date.getTime())) return ''
      const twoDigits = n => String(n).padStart(2, '0')
      const year = date.getFullYear()
      const month = twoDigits(date.getMonth() + 1)
      const day = twoDigits(date.getDate())
      const hour = twoDigits(date.getHours())
      const minute = twoDigits(date.getMinutes())
      return `${year}-${month}-${day}T${hour}:${minute}`
    },
    formatToApiDatetime(datetimeLocal) {
      if (!datetimeLocal) return ''
      return `${datetimeLocal.replace('T', ' ')}:00`
    },
    async submitSetExpiry() {
      const userKode = this.selectedExpiredUser && this.selectedExpiredUser.KODE
      if (!userKode) return

      const expiredAt = this.formatToApiDatetime(this.setExpiryForm.expired_at)
      if (!expiredAt) {
        this.$notif('Validation', 'Expired At is required', 'warning')
        return
      }

      this.isSubmittingSetExpiry = true
      return await this.$http
        .post(`user/${userKode}/set-expiry`, {
          expired_at: expiredAt,
          reason: this.setExpiryForm.reason || '-',
        })
        .then(() => {
          this.$notif('Success', 'Expiry updated successfully', 'success')
          this.getUser()
          this.getUserExpiryHistory(userKode)
          this.showSetExpiryForm = false
        })
        .catch(err => {
          let message = 'Failed to set expiry'
          if (err && err.data && typeof err.data.errors === 'object') {
            message = err.data.errors[Object.keys(err.data.errors)[0]][0]
          } else if (
            err &&
            err.data &&
            typeof err.data.exception === 'object'
          ) {
            message = err.data.exception.message
          }
          this.$notif('Something Error', message, 'danger')
        })
        .finally(() => {
          this.isSubmittingSetExpiry = false
        })
    },
    async getUser() {
      const searchWord = this.searchWord.trim()
      const base = '/user/with.total/true'
      const take = `/take/${this.perPage}`
      const skip = `/skip/${this.skip}`
      const search = `${searchWord !== '' ? `/s/${searchWord}` : ''}`
      const orderBy = `/orderBy.${this.sortBy}/${
        this.sortDesc === true ? 'desc' : 'asc'
      }`
      const complete = base + take + skip + search + orderBy
      this.isBusy = true
      return await this.$http
        .get(complete)
        .then(res => {
          this.items = res.data.data.records
          this.totalData = res.data.data.total
          this.showData = res.data.data.show
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    dummyHttpGetUser() {
      return new Promise(function(resolve, reject) {
        const res = {
          data: dummyData,
        }
        resolve(res)
      })
    },
    async deleteUser(item) {
      this.isBusy = true
      return await this.$http
        .delete(`/user/${item.KODE}`)
        .then(res => {
          this.$notif(
            'Success',
            'User has been successfully deleted.',
            'success'
          )
        })
        .catch(err => {
          let message = ''
          if (typeof err.data.errors === 'object') {
            message = err.data.errors[Object.keys(err.data.errors)[0]][0]
          } else if (typeof err.data.exception === 'object') {
            message = err.data.exception.message
          }
          this.$notif('Something Error', message, 'danger')
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    inputPagination(page) {
      this.currentPage = page
    },
    sortingChanged({ sortBy, sortDesc }) {
      // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
      // ctx.sortDesc ==> true if sorting descending, false otherwise
      if (sortBy !== '') {
        this.sortBy = sortBy
        this.sortDesc = sortDesc
        this.getUser()
      }
    },
    showMsgBoxDelete(item) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          value === true && this.deleteUser(item).then(() => this.getUser())
        })
    },
    async approval(kode) {
      return await this.$http
        .put(`/user/approval/${kode}`)
        .then(res => {
          this.$notif('Success', '', 'success')
          this.getUser()
        })
        .catch(err => {
          let message = ''
          if (typeof err.data.errors === 'object') {
            message = err.data.errors[Object.keys(err.data.errors)[0]][0]
          } else if (typeof err.data.exception === 'object') {
            message = err.data.exception.message
          }
          this.$notif('Something Error', message, 'danger')
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.usr-exp-modal {
  .usr-exp-section {
    border: 1px solid #ebe9f1;
    border-radius: 0.5rem;
  }

  .usr-exp-timeline {
    list-style: disc;
  }
}
</style>
